<template>
  <div>
    <b-card no-body class="overflow-hidden" style="max-width: 540px;" header-tag="header" footer-tag="footer">
      <template #header>
       <h6 class="text-center" style="margin-top:0px;margin-bottom:0px;"><b>Radhasomi</b></h6>
       <hr style="margin-top:0px;margin-bottom:0px;"/>
       <h5 class="text-center" style="margin-top:0px;margin-bottom:0px;"><b>Covid 19 Vaccination Record Card</b></h5>
       <b-card-text class="text-center" style="margin-top:0px;margin-bottom:0px;">
         Radhasoami Satsang, Soamibagh, Agra
      </b-card-text>
      <hr style="margin-top:0px;margin-bottom:0px;"/>
     </template>
     <b-row no-gutters>
       <b-col sm="10">
         <b-card-body style="margin-top:0px;margin-bottom:0px;padding-top:0px;padding-bottom:0px;">
           <b-card-text style="margin-top:0px;margin-bottom:0px;font-size:15px;">
             <b>Sr.No:</b> {{person['srNo']}}
           </b-card-text>
           <b-card-text style="margin-top:0px;margin-bottom:0px;">
             <b>Name:</b> {{person['name']}}
           </b-card-text>
           <b-card-text style="margin-top:0px;margin-bottom:0px;">
             <b-row>
               <b-col><b>Mobile No:</b> {{person['mobile']}}</b-col>
               <b-col><b>AadharCard:</b> {{person['cardNo']}}</b-col>
             </b-row>
           </b-card-text>
           <b-card-text style="margin-top:0px;margin-bottom:0px;">
            <b>Address:</b> {{person['address']}}
           </b-card-text>
         </b-card-body>
      </b-col>

     </b-row>
     <b-table style="margin-top:0px;margin-bottom:0px;" small :items="doses" :fields="fields" id="dataTable" ref="dataTable" responsive="sm">
       <template #cell(dose)="data">
         <b class="text-info">{{ data.value }}</b>
       </template>
       <template #cell(vtype)="data">
         <b class="text-info">{{ data.value }}</b>
       </template>
       <template #cell(date)="data">
         <b class="text-info">{{ data.value }}</b>
       </template>
    </b-table>

    <b-card-footer style="margin-top:0px;margin-bottom:0px;padding-top:0px;padding-bottom:0px;">
       <span>Secretary Signature</span>
    </b-card-footer>
   </b-card>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  name: 'VaccinationPrintCard',

  data: function () {
    return {
      doses:[],
      person:[],
      fields: [

                  {key:'dose', label:'Dose Number'},
                  {key:'vtype', label:'Vaccination Name'}, {key:'date', label:'Vaccination Date'},


              ],

      //{"date":"2021-09-01",vtype:"Name of Vaccinae", dose:1},{}
    };
  },
  methods: {
    setCardData(person,doses){
      this.doses = doses;
      this.person = person;
    },
    resetData(){
      this.doses = [];
      this.person = [];

    }
  }
}

</script>
